import { getApiUrl } from '../config/urls';

const SERVICE = 'web-frontend';
const queue = [];
let flushTimer = null;

function canIngest() {
  const key = process.env.REACT_APP_PLATFORM_LOG_INGEST_KEY;
  if (key && String(key).trim()) return true;
  return process.env.NODE_ENV !== 'production';
}

function normalizeLevel(level) {
  const l = String(level || 'info').toLowerCase();
  if (l === 'warning') return 'warn';
  if (['error', 'warn', 'info', 'success'].includes(l)) return l;
  return 'info';
}

async function flushQueue() {
  if (!canIngest() || queue.length === 0) return;
  const batch = queue.splice(0, 8);
  const apiBase = getApiUrl().replace(/\/$/, '');
  const key = process.env.REACT_APP_PLATFORM_LOG_INGEST_KEY || '';

  await Promise.all(
    batch.map(async (entry) => {
      try {
        await fetch(`${apiBase}/logs/ingest`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(key ? { 'X-Platform-Log-Key': key } : {}),
          },
          body: JSON.stringify({
            ...entry,
            service: SERVICE,
          }),
          keepalive: true,
        });
      } catch {
        /* réseau indisponible */
      }
    })
  );
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushQueue();
  }, 400);
}

/**
 * Envoie un log vers backend-main (table application_logs).
 */
export function reportPlatformLog(level, message, metadata = {}) {
  const msg = String(message || '').trim();
  if (!msg || !canIngest()) return;

  let userEmail = null;
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      userEmail = u?.email || null;
    }
  } catch {
    /* ignore */
  }

  queue.push({
    level: normalizeLevel(level),
    message: msg.slice(0, 4000),
    metadata: metadata && typeof metadata === 'object' ? metadata : {},
    url: typeof window !== 'undefined' ? window.location.href : null,
    userEmail,
  });
  scheduleFlush();
}

export function initPlatformLogReporting() {
  if (typeof window === 'undefined' || !canIngest()) return;

  reportPlatformLog('info', 'Admin web Liberty chargé');

  window.addEventListener('error', (event) => {
    reportPlatformLog('error', event.message || 'Erreur JavaScript', {
      source: event.filename,
      line: event.lineno,
      col: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportPlatformLog(
      'error',
      reason?.message || String(reason || 'Promise rejetée'),
      { stack: reason?.stack ? String(reason.stack).slice(0, 1500) : null }
    );
  });
}

export default { reportPlatformLog, initPlatformLogReporting };
